import React from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {prettyScroll} from "@pg-design/helpers-css";
import {Modal} from "@pg-design/modal-module";

interface IProps {
    children: React.ReactNode;
    onModalClose?: (e: React.MouseEvent | React.KeyboardEvent) => void;
    modalState: boolean;
    title: string;
}

export const ArticleActionModal: React.FC<IProps> = (props) => {
    const {children, modalState, onModalClose, title} = props;

    return (
        <Modal fullScreen isOpen={modalState} onModalClose={onModalClose}>
            <Modal.Header variant="bar">{title}</Modal.Header>
            <Modal.Content>
                <div css={innerWrap}>
                    <ActionModalContent>{children}</ActionModalContent>
                </div>
            </Modal.Content>
        </Modal>
    );
};

const innerWrap = (theme: Theme) => css`
    position: relative;
    max-height: 100vh;
    height: 100%;
    max-width: 100vw;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.sm}) {
        height: 630px;
        width: 810px;
        padding: 0;
    }
`;

const ActionModalContent = styled.div`
    flex-grow: 1;
    flex-shrink: 1;
    overflow-x: hidden;
    padding: 3rem 3.5rem;
    ${prettyScroll()};
`;
